import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  de: {
    translation: {
      'contact': 'KONTAKT',
      'contacts': 'KONTAKTE',
      'sundays': 'Sonntags',
      'tuesdays': 'Dienstags',
      'bank': 'BANKVERBINDUNG',
      'bank.receiver': 'Empfänger',
      'address': 'ADRESSE',
      'networks': 'NETZWERKEN',
      'main.text': 'Wir helfen Menschen Jesus zu finden und ihm nachfolgen',
      'main.button': 'so findest du uns',
      'about.title': 'Eine Kirche, die relevant ist',
      'about.about-us.title': 'ÜBER UNS',
      'about.about-us.text': 'Wir sind die Internationale Christusgemeinde MS – eine lebendige Gemeinschaft für Menschen verschiedener Herkunft. Mehr als nur eine Gemeinde, bieten wir einen Ort, an dem sich jeder willkommen und geborgen fühlen kann. Unser Anliegen ist es, dass Menschen den Sinn des Lebens entdecken und ein erfülltes, gesegnetes Leben führen. Bei uns ist jeder herzlich eingeladen!',
      'about.internal.title': 'LOKALER DIENST',
      'about.internal.text': 'Als Gemeinde setzen wir uns aktiv dafür ein, bedürftigen Menschen in Münster und Umgebung zur Seite zu stehen und ihnen durch die Bibel Hoffnung und einen Weg aus schwierigen Lebenslagen aufzuzeigen. Mit vielfältigen Projekten, Kinder- und Jugendarbeit, Flüchtlingshilfe, Bibelkreisen und Gottesdiensten engagieren wir uns für unsere Mitmenschen. Zudem tragen wir durch unsere Beteiligung an wichtigen gesellschaftlichen Bereichen der Stadt zur Gemeinschaft bei und leisten einen lokalen Beitrag.',
      'about.external.title': 'AKTUELE HILFAKTIONEN',
      'about.external.text': 'Durch unser Hilfswerk Helping Hands und den engagierten Einsatz zahlreicher freiwilliger Helfer leisten wir als Gemeinde aktive Unterstützung in bedürftigen Ländern. Überall dort, wo Armut, Krieg und Leid das Leben der Menschen bestimmen, setzen wir uns mit allen verfügbaren Mitteln ein, um Hoffnung und konkrete Hilfe zu bringen.',
      'vers.title': 'Vers des Tages',
      'location.title': 'UNSER STANDORT',
      'location.schedule.1': 'Gottesdienst',
      'location.schedule.2': 'Hauskreis',
      'fillials.title': 'UNSERE PARTNERGEMEINDEN',
      "fillials.visit-link": "Aufrufen",
      'event1.title': 'Literarisher Abend',
      'event1.time': '21.02.25 18:00',
      'event1.description': 'Du bist herzlich eingeladen,\n' +
        'gemeinsam eine wunderbare Zeit in einer\n' +
        'gemütlichen Atmosphäre zu verbringen, mit\n' +
        'Tee, Snacks und angenehmen Gesprächen,\n' +
        'um unvergessliche Momente zu erleben!',
      'event2.title': 'Seminar',
      'event2.time': '22.02.25 10:00',
      'event2.description': 'Wir laden\n' +
        'Dich herzlich zu einem\n' +
        'Seminar ein, das eine\n' +
        'Oase der Inspiration und\n' +
        'seelischen Harmonie\n' +
        'sein wird.\n' +
        'Wir freuen uns,\n' +
        'Dich zu sehen und gemeinsam\n' +
        'aufbauende Worte und schöne\n' +
        'Zeit zu genießen!',
      'expired-events.title': 'BISHERIGE EVENTS',
      'event3.title': 'GOTTESDIENST MIT METIN GEREGÜL',
      'event3.time': '16.03.25 14:00',
      'event3.description1': 'Ehemaliger Moslem erlebt Jesus!',
      'event3.description2': 'Wenn Sie den Wunsch haben, den Evangelist Metin Geregül bei seiner Missionsreise finanziell zu unterstützen, besuchen Sie diese Website: ',
      'event4.title': 'Sauberes Münster',
      'event4.time': '22.03.25 von 10:00 bis 14:00',
      'event4.description1': '',
      'event4.description2': 'Sie können mein Formular "Sauberes Münster" ',
      'event4.link': 'hier finden',

      'event5.title': 'Einladung zum Weihnachtsgottesdienst | Internationale Christusgemeinde Münster',
      'event5.time': '25.12.25 15:00',
      'event5.description': 'Herzliche Einladung zu unserem Weihnachtsgottesdienst am 25.12. um 15 Uhr!\n' +
          'Wir feiern Weihnachten gemeinsam – entspannt, festlich und voller Freude.\n' +
          '\n' +
          'Nach dem Gottesdienst gibt’s ein leckeres gemeinsames Essen und ein buntes Programm für die ganze Familie. Perfekt, um neue Leute kennenzulernen und Gemeinschaft zu erleben.\n' +
          '\n' +
          'Ob allein, mit Freunden oder mit der ganzen Familie – jeder ist willkommen!\n' +
          'Internationale Christusgemeinde Münster – eine lebendige Freikirche für alle Generationen.',

      'event6.title': 'Adventsabend für Frauen in der Internationalen Christusgemeinde Münster',
      'event6.time': '21.11.25 18:00',
      'event6.description': 'In der Internationalen Christusgemeinde Münster haben wir kurz vor dem ersten Advent einen richtig schönen und gemütlichen Adventsabend für Frauen gefeiert. Unsere Gemeinde und Freikirche wurde an diesem Abend zu einem kreativen Treffpunkt, an dem Frauen aus Münster und Umgebung zusammenkamen, um gemeinsam in die Adventszeit zu starten.\n' +
          '\n' +
          'Bei warmem Kerzenschein, guter Stimmung und vielen netten Gesprächen entstanden ganz unterschiedliche Adventsgestecke – jedes ein echtes Unikat. Die Teilnehmerinnen konnten ihrer Kreativität freien Lauf lassen und gleichzeitig einfach eine entspannte Zeit miteinander genießen.\n' +
          '\n' +
          'Der Abend war eine tolle Gelegenheit, neue Kontakte zu knüpfen, Gemeinschaft zu erleben und sich bewusst auf Weihnachten einzustimmen. Wir haben uns sehr über die vielen Frauen gefreut, die mitgemacht und den Abend so besonders gemacht haben.\n' +
          '\n' +
          'Als Gemeinde gestalten wir regelmäßig Angebote im Rahmen unserer Frauenarbeit – offen, herzlich und für jede Frau, die Lust hat vorbeizuschauen.',

      'event7.title': 'Baby Shower Party in der internationalen Christusgemeinde Münster',
      'event7.time': '21.11.25 18:00',
      'event7.description': 'Ein Tag voller Freude und Gemeinschaft\n' +
          '\n' +
          'In der Internationalen Christusgemeinde Münster, einer herzlichen Freikirche in Münster, durften wir kürzlich eine besondere Baby Shower Party für eine unserer lieben Schwestern feiern. Es war ein wundervoller Nachmittag, an dem Frauen und Girls aus der Gemeinde zusammenkamen, um einander zu unterstützen, Gemeinschaft zu leben und Freude zu teilen.\n' +
          '\n' +
          'Mit viel Liebe, Lachen und warmen Worten entstand eine Atmosphäre, in der sich jede wohlfühlen konnte. Die werdende Mama wurde reich beschenkt und ermutigt – ein Zeichen dafür, wie wertvoll familiäre Nähe und gelebter Glaube in unserer Gemeinde sind.\n' +
          '\n' +
          'Solche Momente erinnern uns daran, wie schön es ist, Teil einer lebendigen Gemeinschaft zu sein, die füreinander da ist. Wir freuen uns schon jetzt auf viele weitere Begegnungen voller Segen, Freude und Verbundenheit.',

      'event9.title': 'Hilfsaktion für die Ukraine – Gemeinsam mit Helping Hands',
      'event9.time': 'Di 17:00 – 20:00 | So 13:00 – 17:00',
      'event9.description': 'Die Internationale Christusgemeinde Münster ist eine freie christliche Gemeinde, die sich aktiv für Menschen in Not einsetzt – sowohl vor Ort als auch international. Unser Glaube an Jesus Christus motiviert uns dazu, praktische Nächstenliebe zu leben und Hoffnung dorthin zu bringen, wo sie dringend gebraucht wird.\n\nAktuell haben wir gemeinsam mit unserem Partner „Helping Hands" aus Waltrop eine Hilfsaktion gestartet, um Menschen in der Ukraine zu unterstützen, die sich in besonders schwierigen Lebensumständen nahe der Frontlinie befinden. Im Rahmen dieser Aktion sammeln wir haltbare Lebensmittel in Form von Konservendosen, um eine direkte und verlässliche Versorgung zu ermöglichen.\n\nMit dieser Initiative möchten wir einen konkreten Beitrag leisten und gleichzeitig ein Zeichen der Solidarität setzen. Jede Spende hilft, die Not ein Stück zu lindern und den Betroffenen zu zeigen, dass sie nicht vergessen sind.\n\nWir danken allen, die diese Aktion unterstützen und gemeinsam mit uns Hoffnung weitergeben.',

      'event8.title': 'Weihnachtsfeier der Internationalen Christusgemeinde Münster',
      'event8.time': '25.12.2025',
      'event8.description': 'Am 25.12.2025 haben wir als Internationale Christusgemeinde Münster gemeinsam die Weihnachtszeit gefeiert und eine besonders gesegnete und herzliche Zeit erlebt. Als Freikirche ist uns die gelebte Gemeinschaft sehr wichtig – und genau diese war an diesem Weihnachtstag deutlich spürbar.\n' +
          '\n' +
          'Im Mittelpunkt stand die Freude über die Geburt von Jesus Christus, der Sinn und Hoffnung von Weihnachten. In einer warmen und offenen Atmosphäre kamen Menschen aus Münster und Umgebung zusammen, um gemeinsam zu feiern, zu singen, zu beten und Zeit miteinander zu verbringen.\n' +
          '\n' +
          'Die Weihnachtsfeier war geprägt von Dankbarkeit, gegenseitiger Wertschätzung und echter Gemeinschaft. Jung und Alt konnten die festliche Stimmung genießen und die Bedeutung von Weihnachten neu erleben.\n' +
          '\n' +
          'Auf dieser Seite teilen wir diverse Fotos, die die schönen Momente dieser Weihnachtsfeier festhalten und einen Einblick in das Gemeindeleben unserer Freikirche geben. Sie zeigen die Freude, das Miteinander und die besondere Atmosphäre, die wir als Internationale Christusgemeinde Münster erleben durften.\n' +
          '\n' +
          'Wir sind dankbar für diese gesegnete Zeit und freuen uns darauf, auch in Zukunft gemeinsam Jesus zu feiern und Gemeinschaft zu leben.',

      'event10.title': 'SOMMERCAMP 2026 – Sei dabei!',
      'event10.time': '21.–22.08.2026 | 16:00 Uhr bis ca. 12:30 Uhr',
      'event10.description': 'Du bist zwischen 12 und 20 Jahren? Dann schnapp dir deine Freunde und verbringe mit uns zwei unvergessliche Tage voller Action, Gemeinschaft und guter Stimmung!\n' +
          '\n' +
          'Dich erwarten:\n' +
          '\n' +
          '• spannende Spiele und Challenges\n' +
          '• ein gemütlicher Filmabend\n' +
          '• Zeit zum Kennenlernen und Austauschen\n' +
          '• leckeres Essen und Getränke – alles inklusive\n' +
          '\n' +
          'Teilnahmebeitrag: nur 5 €\n' +
          '\n' +
          'Das Camp wird von der Freikirche Internationale Christusgemeinde Münster organisiert.\n' +
          '\n' +
          'Wichtig: Die Anmeldung ist bis zum 17. August möglich.',

      'event11.title': 'Weihnachten an der Frontlinie 2026 – Schuhkarton-Aktion',
      'event11.time': 'Abgabe bis 12.12.2026 | So 13:00 – 17:00',
      'event11.description': 'Kleine Geschenke. Große Hoffnung.\n' +
          '\n' +
          'Gemeinsam mit unserem Hilfswerk Helping Hands Social Charity Mission packen wir Schuhkartons mit nützlichen Dingen und kleinen Überraschungen. Gemeinsam schenken wir Kindern an der Frontlinie nicht nur Dinge des Alltags, sondern auch Hoffnung, Wärme und ein Lächeln.\n' +
          '\n' +
          'So packst du deinen Schuhkarton für die Kinder in der Ukraine:\n' +
          '\n' +
          '1. Mit folgenden Dingen befüllen:\n' +
          '1 A4 Schreibblock, 1 A4 Malbuch, 12 Bunt- oder Filzstifte, 2 Bleistifte, 1 Radiergummi, 1 Anspitzer, 2 Päckchen Bonbons, 1 Haarbürste, 1 Handtuch 50x70 cm, 1 Kinderduschgel, 1 Kindershampoo, 1 Zahnbürste, 1 Zahnpasta, 1 Spielzeug\n' +
          '2. Mit Geschenkpapier bekleben\n' +
          '3. Beschriften mit z. B. BOY 1–6 Jahre oder GIRL 6–8 Jahre\n' +
          '4. Geschenkpäckchen abgeben bei: Höftestraße 12, 48167 Münster, sonntags von 13:00 bis 17:00 Uhr\n' +
          '5. Unterstütze den Transport gerne finanziell:\n' +
          'Helping Hands Social Charity Mission e.V.\n' +
          'IBAN: DE85 4526 0475 0018 6175 00\n' +
          'Verwendungszweck: Weihnachtstransport 2026\n' +
          '\n' +
          'Abgabeschluss ist der 12.12.2026.\n' +
          'Jedes Geschenk zählt – vielen Dank für deine Unterstützung!',

      'event12.title': 'Internationale Christusgemeinde Münster – Gemeinsam im Glauben wachsen',
      'event12.time': 'Jeden Sonntag um 14:00 Uhr',
      'event12.description': 'Wir sind die Internationale Christusgemeinde Münster, eine Freikirche, in der Jesus Christus im Mittelpunkt unseres Glaubens und unseres Lebens steht. Als Gemeinde möchten wir Menschen zusammenbringen, unseren Glauben gemeinsam leben und Gottes Liebe in unserem Alltag sichtbar machen.\n' +
          '\n' +
          'Wir kommen regelmäßig sonntags um 14:00 Uhr zusammen, um Gott anzubeten, sein Wort zu hören, gemeinsam zu beten und Gemeinschaft miteinander zu erleben. Dabei freuen wir uns über jeden Menschen, der uns kennenlernen und mit uns den Glauben an Jesus Christus entdecken oder vertiefen möchte.\n' +
          '\n' +
          'Ein besonderes Highlight in diesem Jahr war unsere gemeinsame Tauffeier. Wir durften miterleben, wie vier Menschen ihr Leben Jesus Christus anvertraut und mit ihrer Taufe ihren Glauben öffentlich bezeugt haben. Dieser besondere Schritt ist ein Ausdruck ihrer Entscheidung, Jesus nachzufolgen und ihr Leben mit ihm zu gestalten. Für unsere gesamte Gemeinde war es ein bewegender und freudiger Anlass, für den wir Gott von Herzen dankbar sind.\n' +
          '\n' +
          'Wir glauben, dass jeder Mensch bei Gott willkommen ist und dass wir gemeinsam im Glauben wachsen können. Deshalb möchten wir ein Ort sein, an dem Menschen Jesus begegnen, Freundschaften entstehen und der Glaube im Alltag lebendig wird.\n' +
          '\n' +
          'Du bist herzlich eingeladen, uns kennenzulernen und Teil unserer Gemeinschaft zu werden!\n' +
          '\n' +
          '📍 Unsere Adresse:\n' +
          'Internationale Christusgemeinde Münster\n' +
          'Höftestraße 12\n' +
          '48167 Münster\n' +
          '\n' +
          '🕑 Unsere Gottesdienste:\n' +
          'Jeden Sonntag um 14:00 Uhr\n' +
          '\n' +
          'Wir freuen uns darauf, dich willkommen zu heißen!',

      'event13.title': 'Weihnachtskekse backen für Kinder',
      'event13.time': '11.12.2026 | 17:00 Uhr',
      'event13.description': 'Die Weihnachtszeit ist eine besondere Zeit voller Freude, Liebe und Gemeinschaft!\n' +
          '\n' +
          'Die Internationale Christusgemeinde Münster, eine Freikirche in Münster, lädt alle Kinder herzlich zu einer gemütlichen Weihnachtsaktion ein.\n' +
          '\n' +
          'Am 11. Dezember 2026 um 17:00 Uhr möchten wir gemeinsam mit den Kindern leckere Weihnachtskekse backen, kreativ sein und eine schöne Zeit miteinander verbringen.\n' +
          '\n' +
          'Dabei stehen Spaß, Freude und Gemeinschaft im Mittelpunkt. Wir möchten den Kindern einen Ort bieten, an dem sie neue Freunde kennenlernen, gemeinsam lachen und die vorweihnachtliche Zeit in einer liebevollen Atmosphäre erleben können.\n' +
          '\n' +
          'Alle Kinder sind herzlich willkommen!\n' +
          'Kinder von 6 bis 10 Jahren können selbstständig und ohne Eltern teilnehmen. Jüngere Kinder können in Begleitung ihrer Eltern teilnehmen.\n' +
          '\n' +
          'Kosten: 5 €\n' +
          '\n' +
          '📍 Ort:\n' +
          'Höftestraße 12, 48167 Münster\n' +
          '\n' +
          'Wichtig: Anmeldung erforderlich!\n' +
          'Bitte meldet eure Kinder bis spätestens zum 01. Dezember 2026 an. Scannt dazu den QR-Code auf dem Plakat.\n' +
          '\n' +
          'Wir freuen uns auf viele kleine Bäckerinnen und Bäcker und auf einen wunderschönen Nachmittag voller Freude, Gemeinschaft und Weihnachtsstimmung!',

    }
  },
  ru: {
    translation: {
      'contact': 'КОНТАКТ',
      'contacts': 'КОНТАКТЫ',
      'sundays': 'Воскресенье',
      'tuesdays': 'Вторник',
      'bank': 'БАНКОВСКИЕ РЕКВИЗИТЫ',
      'bank.receiver': 'Получатель',
      'address': 'АДРЕС',
      'networks': 'СЕТИ',
      'main.text': 'Мы помогаем людям найти Иисуса и последовать за Ним',
      'main.button': 'как нас найти',
      'about.title': 'ЦЕРКОВЬ, КОТОРАЯ АКТУАЛЬНА',
      'about.about-us.title': 'О НАС',
      'about.about-us.text': 'Мы — Международная Христова Церковь MS, не просто община, а дружное сообщество людей разных национальностей и культур. Мы стремимся создать атмосферу, в которой каждый чувствует себя комфортно, находит смысл жизни и живёт благословенной жизнью. Двери нашей церкви открыты для всех!',
      'about.internal.title': 'ВНУТРЕННЕЕ СЛУЖЕНИЕ',
      'about.internal.text': 'Как церковь, мы стремимся помогать нуждающимся в Мюнстере и его окрестностях, показывая через Библию путь к выходу из сложных жизненных ситуаций. Различные проекты, работа с детьми и молодёжью, помощь беженцам, библейские кружки и богослужения, а также активное участие в жизни города помогают нам вносить свой вклад в местное общество.',
      'about.external.title': 'ВНЕШНЕЕ СЛУЖЕНИЕ',
      'about.external.text': 'Через нашу благотворительную организацию Helping Hands и усилия множества добровольцев мы оказываем поддержку людям в нуждающихся странах. Там, где царят бедность, война и страдания, мы стараемся быть на передовой, помогая всеми возможными средствами.',
      'vers.title': 'Библейский стих дня',
      'location.title': 'НАШЕ МЕСТОПОЛОЖЕНИЕ',
      'location.schedule.1': 'Богослужение',
      'location.schedule.2': 'Домашняя группа',
      'fillials.title': 'НАШИ ФИЛИАЛЫ',
      "fillials.visit-link": "Перейти",
      'event1.title': 'СЕМИНАР',
      'event1.time': '21.02.25 18:00',
      'event1.description': 'Ты сердечно приглашён(-а) провести вместе чудесное время в уютной атмосфере за чашкой чая, угощениями и приятными беседами, чтобы пережить незабываемые моменты!',
      'event2.title': 'ЛИТЕРАТУРНЫЙ ВЕЧЕР',
      'event2.time': '22.02.25 10:00',
      'event2.description': 'Мы сердечно приглашаем тебя на семинар, который станет оазисом вдохновения и душевной гармонии. Мы будем рады видеть тебя и вместе насладиться вдохновляющими словами и прекрасным временем!',"event3.title": "БОГОСЛУЖЕНИЕ С МЕТИНОМ ГЕРЕГЮЛЕМ",
      "event3.time": "16.03.25 14:00",
      "event3.description1": "Бывший мусульманин встречает Иисуса!",
      "event3.description2": "Если у вас есть желание финансово поддержать евангелиста Метина Герегюля в его миссионерском путешествии, посетите этот сайт: ",
      "event4.title": "Чистый Мюнстер",
      "event4.time": "22.03.25 с 10:00 до 14:00",
      "event4.description1": "",
      "event4.description2": "Вы можете найти мою форму \"Чистый Мюнстер\" ",
      "event4.link": "здесь",

      'event5.title': 'Приглашение на рождественское богослужение | Международная христианская церковь Мюнстера',
      'event5.time': '25.12.25 15:00',
      'event5.description': 'Сердечно приглашаем вас на наше рождественское богослужение 25 декабря в 15:00!\n' +
          'Мы будем праздновать Рождество вместе — спокойно, торжественно и с радостью.\n' +
          '\n' +
          'После богослужения будет вкусная общая трапеза и разнообразная программа для всей семьи — отличный повод познакомиться с новыми людьми и почувствовать атмосферу общения.\n' +
          '\n' +
          'Вы можете прийти одни, с друзьями или всей семьёй — каждый желанный гость!\n' +
          'Международная христианская церковь Мюнстера — живая свободная церковь для всех поколений.',

      'event6.title': 'Адвент-вечер для женщин в Международной христианской церкви Мюнстера',
      'event6.time': '21.11.25 18:00',
      'event6.description': 'В Международной христианской церкви Мюнстера мы незадолго до первого Адвента провели по-настоящему красивый и уютный адвент-вечер для женщин. В этот вечер наша церковь и свободная церковь стали творческой площадкой, где женщины из Мюнстера и окрестностей собрались вместе, чтобы начать адвентский сезон.\n' +
          '\n' +
          'При тёплом свете свечей, в приятной атмосфере и за множеством дружеских бесед были созданы самые разные адвентские композиции — каждая по-своему уникальная. Участницы смогли дать волю своей фантазии и просто насладиться спокойным временем вместе.\n' +
          '\n' +
          'Этот вечер стал прекрасной возможностью завести новые знакомства, почувствовать единство и сознательно настроиться на Рождество. Мы были очень рады видеть так много женщин, которые присоединились и сделали этот вечер особенным.\n' +
          '\n' +
          'Как церковь мы регулярно проводим различные мероприятия в рамках нашего женского служения — открытые, сердечные и для каждой женщины, которой интересно заглянуть к нам.',

      'event7.title': 'Baby Shower Party в Международной Христианской Общине Мюнстера',
      'event7.time': '21.11.25 18:00',
      'event7.description': 'День, полный радости и общения\n' +
          '\n' +
          'В Международной Христианской Общине Мюнстера, тёплой и гостеприимной свободной церкви, мы недавно провели особенную Baby Shower Party для одной из наших дорогих сестёр. Это был чудесный день, когда женщины и девушки из церкви собрались вместе, чтобы поддержать друг друга, разделить общение и подарить радость.\n' +
          '\n' +
          'В атмосфере, наполненной любовью, смехом и тёплыми словами, каждая чувствовала себя комфортно и спокойно. Будущая мама получила много подарков и ободрения — знак того, насколько ценны семейная близость и живая вера в нашей общине.\n' +
          '\n' +
          'Такие моменты напоминают нам, как прекрасно быть частью живой общины, где люди поддерживают друг друга. И мы уже с радостью ждём новых встреч, наполненных благословением, радостью и единством.',

      'event9.title': 'Акция помощи Украине – вместе с Helping Hands',
      'event9.time': 'Вт 17:00 – 20:00 | Вс 13:00 – 17:00',
      'event9.description': 'Международная Христова Церковь Мюнстера — свободная христианская церковь, которая активно помогает людям в беде — как на местном уровне, так и в международном масштабе. Наша вера в Иисуса Христа побуждает нас жить практической любовью к ближнему и нести надежду туда, где она так необходима.\n\nВ настоящее время совместно с нашим партнёром «Helping Hands» из Вальтропа мы начали акцию помощи людям на Украине, которые находятся в особенно тяжёлых жизненных условиях вблизи линии фронта. В рамках этой акции мы собираем продукты длительного хранения в виде консервов, чтобы обеспечить прямую и надёжную поставку продовольствия.\n\nС этой инициативой мы хотим внести конкретный вклад и одновременно выразить солидарность. Каждое пожертвование помогает немного облегчить нужду и показать пострадавшим, что о них не забыли.\n\nМы благодарны всем, кто поддерживает эту акцию и вместе с нами несёт надежду.',

      'event8.title': 'Рождественское празднование Международной Церкви Христа в Мюнстере',
      'event8.time': '25.12.2025',
      'event8.description': '25.12.2025 мы, как Международная Церковь Христа в Мюнстере, вместе отпраздновали рождественское время и пережили особенно благословенное и тёплое общение. Как свободная церковь, мы придаём большое значение живому общению, и именно оно было особенно ощутимо в этот рождественский день.\n' +
          '\n' +
          'В центре внимания была радость по поводу рождения Иисуса Христа — смысла и надежды Рождества. В тёплой и открытой атмосфере люди из Мюнстера и окрестностей собрались вместе, чтобы праздновать, петь, молиться и проводить время друг с другом.\n' +
          '\n' +
          'Рождественский праздник был наполнен благодарностью, взаимным уважением и настоящим общением. И молодые, и пожилые смогли насладиться праздничной атмосферой и по-новому пережить значение Рождества.\n' +
          '\n' +
          'На этой странице мы делимся различными фотографиями, которые запечатлели прекрасные моменты этого рождественского праздника и дают представление о церковной жизни нашей свободной церкви. Они показывают радость, единство и особую атмосферу, которую мы смогли пережить как Международная Церковь Христа в Мюнстере.\n' +
          '\n' +
          'Мы благодарны за это благословенное время и с радостью ждём возможности и в будущем вместе прославлять Иисуса и жить в общении.',

      'event10.title': 'ЛЕТНИЙ ЛАГЕРЬ 2026 – Присоединяйся!',
      'event10.time': '21–22.08.2026 | с 16:00 до примерно 12:30',
      'event10.description': 'Тебе от 12 до 20 лет? Тогда бери с собой друзей и проведи вместе с нами два незабываемых дня, полных активностей, общения и отличного настроения!\n' +
          '\n' +
          'Тебя ждут:\n' +
          '\n' +
          '• увлекательные игры и испытания\n' +
          '• уютный киновечер\n' +
          '• время для знакомств и общения\n' +
          '• вкусная еда и напитки – всё включено\n' +
          '\n' +
          'Оргвзнос: всего 5 €\n' +
          '\n' +
          'Лагерь организует свободная церковь «Международная Христианская Община Мюнстера».\n' +
          '\n' +
          'Важно: регистрация возможна до 17 августа.',

      'event11.title': 'Рождество на линии фронта 2026 – акция «Подарок в обувной коробке»',
      'event11.time': 'Сдать до 12.12.2026 | Вс 13:00 – 17:00',
      'event11.description': 'Маленькие подарки. Большая надежда.\n' +
          '\n' +
          'Вместе с нашей благотворительной организацией Helping Hands Social Charity Mission мы собираем обувные коробки с полезными вещами и маленькими сюрпризами. Вместе мы дарим детям на линии фронта не только вещи для повседневной жизни, но и надежду, тепло и улыбку.\n' +
          '\n' +
          'Как собрать обувную коробку для детей в Украине:\n' +
          '\n' +
          '1. Положи в коробку:\n' +
          '1 блокнот A4, 1 раскраску A4, 12 цветных карандашей или фломастеров, 2 простых карандаша, 1 ластик, 1 точилку, 2 пачки конфет, 1 расчёску, 1 полотенце 50x70 см, 1 детский гель для душа, 1 детский шампунь, 1 зубную щётку, 1 зубную пасту, 1 игрушку\n' +
          '2. Обклей коробку подарочной бумагой\n' +
          '3. Подпиши, например: BOY 1–6 лет или GIRL 6–8 лет\n' +
          '4. Сдай подарок по адресу: Höftestraße 12, 48167 Münster, по воскресеньям с 13:00 до 17:00\n' +
          '5. По желанию поддержи перевозку финансово:\n' +
          'Helping Hands Social Charity Mission e.V.\n' +
          'IBAN: DE85 4526 0475 0018 6175 00\n' +
          'Назначение платежа: Weihnachtstransport 2026\n' +
          '\n' +
          'Последний день приёма подарков — 12.12.2026.\n' +
          'Каждый подарок важен — спасибо за твою поддержку!',

      'event12.title': 'Международная Христова Церковь Мюнстера – вместе возрастать в вере',
      'event12.time': 'Каждое воскресенье в 14:00',
      'event12.description': 'Мы — Международная Христова Церковь Мюнстера, свободная церковь, в которой Иисус Христос находится в центре нашей веры и нашей жизни. Как община, мы хотим объединять людей, вместе жить нашей верой и делать Божью любовь видимой в повседневной жизни.\n' +
          '\n' +
          'Мы регулярно собираемся по воскресеньям в 14:00, чтобы поклоняться Богу, слушать Его Слово, вместе молиться и переживать общение друг с другом. Мы рады каждому, кто хочет познакомиться с нами и вместе с нами открыть для себя или углубить веру в Иисуса Христа.\n' +
          '\n' +
          'Особым событием этого года стало наше общее празднование крещения. Мы стали свидетелями того, как четыре человека доверили свою жизнь Иисусу Христу и через крещение публично засвидетельствовали свою веру. Этот особый шаг — выражение их решения следовать за Иисусом и строить свою жизнь вместе с Ним. Для всей нашей церкви это было трогательное и радостное событие, за которое мы от всего сердца благодарны Богу.\n' +
          '\n' +
          'Мы верим, что каждый человек желанен для Бога и что вместе мы можем возрастать в вере. Поэтому мы хотим быть местом, где люди встречают Иисуса, где рождается дружба и где вера оживает в повседневной жизни.\n' +
          '\n' +
          'Сердечно приглашаем тебя познакомиться с нами и стать частью нашей общины!\n' +
          '\n' +
          '📍 Наш адрес:\n' +
          'Internationale Christusgemeinde Münster\n' +
          'Höftestraße 12\n' +
          '48167 Münster\n' +
          '\n' +
          '🕑 Наши богослужения:\n' +
          'Каждое воскресенье в 14:00\n' +
          '\n' +
          'Будем рады приветствовать тебя!',

      'event13.title': 'Выпечка рождественского печенья для детей',
      'event13.time': '11.12.2026 | 17:00',
      'event13.description': 'Рождественское время — особое время, полное радости, любви и общения!\n' +
          '\n' +
          'Международная Христова Церковь Мюнстера, свободная церковь в Мюнстере, сердечно приглашает всех детей на уютную рождественскую акцию.\n' +
          '\n' +
          '11 декабря 2026 года в 17:00 мы хотим вместе с детьми испечь вкусное рождественское печенье, заняться творчеством и провести прекрасное время друг с другом.\n' +
          '\n' +
          'В центре — веселье, радость и общение. Мы хотим дать детям место, где они могут завести новых друзей, вместе смеяться и пережить предрождественское время в тёплой атмосфере.\n' +
          '\n' +
          'Все дети сердечно приглашены!\n' +
          'Дети от 6 до 10 лет могут участвовать самостоятельно, без родителей. Младшие дети могут участвовать в сопровождении родителей.\n' +
          '\n' +
          'Стоимость: 5 €\n' +
          '\n' +
          '📍 Место:\n' +
          'Höftestraße 12, 48167 Münster\n' +
          '\n' +
          'Важно: необходима регистрация!\n' +
          'Пожалуйста, запишите своих детей не позднее 1 декабря 2026 года. Для этого отсканируйте QR-код на плакате.\n' +
          '\n' +
          'Мы ждём много маленьких пекарей и пекарищ и прекрасный день, полный радости, общения и рождественского настроения!',

    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "de",
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
